<template>
  <v-layout justify-space-between class="group-header">
    <span>{{title}}</span>
    <span>{{summaryText}}</span>
  </v-layout>
</template>

<script>

  export default {
    name: "GroupHeader",
    props: {
      title: {
        type: String,
        required: true,
      },
      summaryText: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>

  @import "@/assets/scss/abstract/_mixins.scss";

  .group-header {
    width: 100%;
    height: 40px;
    flex-grow: 0;
    background-color: #f5f6f9;
    font-family: var(--primary-font-family);
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 40px;
    letter-spacing: normal;
    padding: 0 20px;
    color: #596671;
    border-bottom: 1px solid #dadce0;

    @include md-and-up {
      font-size: 12px;
      background-color: #FBFCFC;
    }
  }

</style>
